var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-view"},[_c('header-component'),_c('router-view'),_c('footer-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }